import React from "react";
import { STATUS_COLORS } from "../config/chartColors";

// Иконки для карточек
const icons = {
    clock: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
    ),
    overtime: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
    ),
    exit: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
        </svg>
    ),
    missing: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
        </svg>
    ),
};

export const KpiCard = ({
    title,
    value,
    percent,
    status = "neutral",
    icon = "clock",
}) => {
    // Определение цвета в зависимости от статуса
    const color = STATUS_COLORS[status] || STATUS_COLORS.neutral;

    return (
        <div className="bg-[#2D2D30] rounded-lg shadow p-5 border border-[#3E3E42]">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-lg font-medium text-gray-300">
                        {title}
                    </h3>
                    <div className="flex items-baseline mt-1">
                        <span className="text-3xl font-semibold text-white">
                            {value}
                        </span>
                        <span className="ml-2 text-sm text-gray-400">
                            случаев
                        </span>
                    </div>
                </div>

                <div
                    className="p-3 rounded-full"
                    style={{ backgroundColor: `${color}20` }}
                    aria-hidden="true"
                >
                    <div style={{ color }}>{icons[icon] || icons.clock}</div>
                </div>
            </div>

            <div className="mt-4">
                <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-400">
                        Процент от всех смен
                    </span>
                    <span className="text-sm font-medium" style={{ color }}>
                        {percent}%
                    </span>
                </div>

                <div className="w-full bg-[#1E1E1E] rounded-full h-2 mt-1">
                    <div
                        className="h-2 rounded-full"
                        style={{
                            width: `${Math.min(percent, 100)}%`,
                            backgroundColor: color,
                        }}
                        role="progressbar"
                        aria-valuenow={percent}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    ></div>
                </div>
            </div>
        </div>
    );
};
